import React, { useEffect, useState } from "react";
import ExtraRegimeField from "./extraRegimeVal";
import FirstRegimeField from "./regimeVal";

const RegimeFields = ({ isMonoRegime, article, onArticleChange }) => { 

  const [regimeVal, setRegimeVal] = useState(undefined);
  const [regimeFind, setRegimeFind] = useState("");

  useEffect(() => {
    if (!article?.regimeId) return;
    setRegimeVal(article.regimeId);
  }, [article?.regimeId]);

  return (
    <>
      {isMonoRegime === "MULTI" ?
        <FirstRegimeField
          data-testid={"RegimeFields"}
          isAccountRow={true}
          article={article}
          regimeVal={regimeVal}
          setRegimeVal={setRegimeVal}
          onArticleChange={onArticleChange}
          regimeFind={regimeFind}
          isMonoRegime={isMonoRegime}
        />
        : <div style={{ width: "40%" }}>&nbsp;</div>}
      <ExtraRegimeField
        data-testid={"RegimeFields"}
        isAccountRow={true}
        article={article}
        regimeVal={regimeVal}
        setRegimeVal={setRegimeVal}
        onArticleChange={onArticleChange}
        regimeFind={regimeFind}
        isMonoRegime={isMonoRegime}
        setRegimeFind={setRegimeFind}
      />
    </>
  );
};

export default RegimeFields;
